import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Button } from "antd";
import _ from "i18n";

import { setCollaboratorZones, setCollaboratorBus } from "Actions";
import {
  deleteCollaboratorZone,
  saveCollaboratorZone,
  deleteCollaboratorBu,
  saveCollaboratorBu,
  fetchSettingCollaborators,
  fetchCollaboratorSettingSuggestions
} from "Thunks";

import { onSuccess, onError } from "Utils";
import { DIALOG_TYPES } from "../../config";
import TTPDialog from "../Common/TTPDialog";
import { SettingIcon, SvgIcon, ICONS, GarbageIcon } from "../Common/Icons";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";

import styles from "./RegimeSettingContent.local.scss";

class LocalizationSettingContent extends Component {
  // **** LocalizationSettingContent (functions) ***** //
  constructor(props) {
    super(props);
    this.state = {
      idZone: null,
      idBu: null,
      zone: {
        id: null,
        label: ""
      },
      bu: {
        id: null,
        label: ""
      },
      disabledSaveZone: true,
      disabledSaveBu: true,
      deleteZoneIsVisible: false,
      deleteBuIsVisible: false,
      savedZoneForm: false,
      savedBuForm: false
    };
  }

  // **** ZoneSetting functions ***** //
  handleDisplayDeleteZone = id => {
    this.setState({
      idZone: id,
      deleteZoneIsVisible: true
    });
  };

  handleDeleteZone = () => {
    const { settingSuggestions } = this.props;
    let updatedZones = settingSuggestions.data.zones;
    let { idZone } = this.state;
    this.setState({ loading: true });

    this.props.dispatch(deleteCollaboratorZone(idZone)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("zoneDeleted")
        });
        this.props.dispatch(
          setCollaboratorZones(updatedZones.filter(({ id }) => id !== idZone))
        );
        this.props.dispatch(fetchSettingCollaborators());
        this.cancelDeleteZone();
      },
      err => {
        this.cancelDeleteZone();
        this.setState({ loading: false });
        onError(err.response.data.errors[0].message);
      }
    );
  };

  cancelDeleteZone = () => {
    this.setState({
      idZone: null,
      deleteZoneIsVisible: false
    });
  };

  handlePrepareUpdateZone = zoneToUpdate => {
    this.setState({ zone: zoneToUpdate });
  };

  handleChangeZoneLabel = event => {
    this.setState({
      zone: { ...this.state.zone, label: event.target.value },
      disabledSaveZone: false
    });
  };

  cancelUpdateZone = () => {
    this.setState({
      zone: {
        id: null,
        label: ""
      },
      disabledSaveZone: true
    });
  };

  handleSaveZone = () => {
    const { zone } = this.state;
    const { dispatch } = this.props;

    // TODO Check if all fields are assigned.

    this.setState({ savedZoneForm: true });
    dispatch(saveCollaboratorZone(zone)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: zone.id ? _("zoneUpdated") : _("zoneCreated")
        });

        dispatch(fetchCollaboratorSettingSuggestions());
        this.setState({
          disabledSaveZone: true,
          savedZoneForm: false,
          zone: {
            id: null,
            label: ""
          }
        });
      },
      err => {
        onError(
          err.response.data.errors
            ? err.response.data.errors[0].message
            : _("error")
        );
      }
    );
  };

  // **** BuSetting functions ***** //
  handleDisplayDeleteBu = id => {
    this.setState({
      idBu: id,
      deleteBuIsVisible: true
    });
  };

  handleDeleteBu = () => {
    const { settingSuggestions } = this.props;
    let updatedBus = settingSuggestions.data.bus;
    let { idBu } = this.state;
    this.setState({ loading: true });

    this.props.dispatch(deleteCollaboratorBu(idBu)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("buDeleted")
        });
        this.props.dispatch(
          setCollaboratorBus(updatedBus.filter(({ id }) => id !== idBu))
        );
        this.props.dispatch(fetchSettingCollaborators());
        this.cancelDeleteBu();
      },
      err => {
        this.cancelDeleteBu();
        this.setState({ loading: false });
        onError(err.response.data.errors[0].message);
      }
    );
  };

  cancelDeleteBu = () => {
    this.setState({
      idBu: null,
      deleteBuIsVisible: false
    });
  };

  handlePrepareUpdateBu = buToUpdate => {
    this.setState({ bu: buToUpdate });
  };

  handleChangeBuLabel = event => {
    this.setState({
      bu: { ...this.state.bu, label: event.target.value },
      disabledSaveBu: false
    });
  };

  cancelUpdateBu = () => {
    this.setState({
      bu: {
        id: null,
        label: ""
      },
      disabledSaveBu: true
    });
  };

  handleSaveBu = () => {
    const { bu } = this.state;
    const { dispatch } = this.props;

    // TODO Check if all fields are assigned.

    this.setState({ savedBuForm: true });
    dispatch(saveCollaboratorBu(bu)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: bu.id ? _("buUpdated") : _("buCreated")
        });

        dispatch(fetchCollaboratorSettingSuggestions());
        this.setState({
          disabledSaveBu: true,
          savedBuForm: false,
          bu: {
            id: null,
            label: ""
          }
        });
      },
      err => {
        onError(
          err.response.data.errors
            ? err.response.data.errors[0].message
            : _("error")
        );
      }
    );
  };

  render() {
    const { settingSuggestions } = this.props;
    const { zone, bu } = this.state;
    return (
      <div className="tamtam-modal upload-modal upload-modal__body">
        <ModalCloseButton onClose={this.props.onCancel} />
        <div className="upload-modal__content">
          <div className="upload-modal__header small-12">
            <div className="upload-modal__header-icon">
              <SettingIcon fill="#2495E1" size="20" />
            </div>
            <div className="upload-modal__header-title">
              {_("titleModalLocalization")}
            </div>
          </div>
          <div className={styles.modal_content}>
            <div className={classnames("columns medium-6 small-6")}>
              <div
                className={classnames(
                  "columns medium-12 small-12",
                  styles.form_frame_minim
                )}
              >
                <h3>{_(zone.id ? "updateZone" : "createZone")}</h3>
                <div
                  className={classnames(
                    "columns medium-12 small-12",
                    styles.input_div
                  )}
                >
                  <span>{_("title")}</span>
                  <input
                    type={"text"}
                    value={zone.label}
                    onChange={event => this.handleChangeZoneLabel(event)}
                  />
                </div>
                <div>
                  <button
                    type={"success"}
                    className={styles.save_button}
                    disabled={this.state.disabledSaveZone}
                    onClick={this.handleSaveZone}
                  >
                    <img
                      src={"/img/icons/tail-spin.svg"}
                      alt={""}
                      className={
                        settingSuggestions.saving && this.state.savedZoneForm
                          ? styles.loading
                          : ""
                      }
                    />
                    {_("save")}
                  </button>
                  {zone.id && (
                    <Button
                      type={"success"}
                      style={{
                        fontFamily: "Roboto",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: 14,
                        height: 37,
                        margin: "5px 3px 0px",
                        background: "transparent",
                        float: "left",
                        textTransform: "uppercase",
                        color: "#6D7F92"
                      }}
                      onClick={() => this.cancelUpdateZone()}
                    >
                      {_("cancel")}
                    </Button>
                  )}
                </div>
              </div>
              <div
                className={classnames(
                  "columns medium-12 small-12",
                  styles.list_frame
                )}
              >
                <h3>
                  {_("zonesList")} ({settingSuggestions.data.zones.length})
                </h3>
                <div className={`${styles.list_items} ${styles.list_zones}`}>
                  {settingSuggestions.fetching ? (
                    <div className={styles.ripple_loading}>
                      <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                    </div>
                  ) : (
                    settingSuggestions.data.zones &&
                    settingSuggestions.data.zones.map(zone => {
                      return (
                        <div key={zone.id} className={styles.item}>
                          <span>{zone.label}</span>
                          <div
                            className={styles.actions}
                            onClick={event => {
                              event.stopPropagation();
                            }}
                          >
                            <div>
                              <span
                                className={`${styles.action} ${
                                  styles.action_edit
                                }`}
                                onClick={() =>
                                  this.handlePrepareUpdateZone(zone)
                                }
                              >
                                <SvgIcon
                                  icon={ICONS.PENCIL}
                                  className={styles.edit}
                                />
                              </span>
                              <span
                                className={`${styles.action} ${
                                  styles.action_delete
                                }`}
                                onClick={() =>
                                  this.handleDisplayDeleteZone(zone.id)
                                }
                              >
                                <SvgIcon
                                  icon={ICONS.Garbage}
                                  className={styles.delete}
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
            <div className={classnames("columns medium-6 small-6")}>
              <div
                className={classnames(
                  "columns medium-12 small-12",
                  styles.form_frame_minim
                )}
              >
                <h3>{_(bu.id ? "updateBu" : "createBu")}</h3>
                <div
                  className={classnames(
                    "columns medium-12 small-12",
                    styles.input_div
                  )}
                >
                  <span>{_("title")}</span>
                  <input
                    type={"text"}
                    value={bu.label}
                    onChange={event => this.handleChangeBuLabel(event)}
                  />
                </div>
                <div>
                  <button
                    type={"success"}
                    className={styles.save_button}
                    disabled={this.state.disabledSaveBu}
                    onClick={this.handleSaveBu}
                  >
                    <img
                      src={"/img/icons/tail-spin.svg"}
                      alt={""}
                      className={
                        settingSuggestions.saving && this.state.savedBuForm
                          ? styles.loading
                          : ""
                      }
                    />
                    {_("save")}
                  </button>
                  {bu.id && (
                    <Button
                      type={"success"}
                      style={{
                        fontFamily: "Roboto",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: 14,
                        height: 37,
                        margin: "5px 3px 0px",
                        background: "transparent",
                        float: "left",
                        textTransform: "uppercase",
                        color: "#6D7F92"
                      }}
                      onClick={() => this.cancelUpdateBu()}
                    >
                      {_("cancel")}
                    </Button>
                  )}
                </div>
              </div>
              <div
                className={classnames(
                  "columns medium-12 small-12",
                  styles.list_frame
                )}
              >
                <h3>
                  {_("busList")} ({settingSuggestions.data.bus.length})
                </h3>
                <div className={`${styles.list_items} ${styles.list_bus}`}>
                  {settingSuggestions.fetching ? (
                    <div className={styles.ripple_loading}>
                      <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                    </div>
                  ) : (
                    settingSuggestions.data.bus &&
                    settingSuggestions.data.bus.map(bu => {
                      return (
                        <div key={bu.id} className={styles.item}>
                          <span>{bu.label}</span>
                          <div
                            className={styles.actions}
                            onClick={event => {
                              event.stopPropagation();
                            }}
                          >
                            <div>
                              <span
                                className={`${styles.action} ${
                                  styles.action_edit
                                }`}
                                onClick={() => this.handlePrepareUpdateBu(bu)}
                              >
                                <SvgIcon
                                  icon={ICONS.PENCIL}
                                  className={styles.edit}
                                />
                              </span>
                              <span
                                className={`${styles.action} ${
                                  styles.action_delete
                                }`}
                                onClick={() =>
                                  this.handleDisplayDeleteBu(bu.id)
                                }
                              >
                                <SvgIcon
                                  icon={ICONS.Garbage}
                                  className={styles.delete}
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <TTPDialog
          showDialog={this.state.deleteZoneIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteZone,
            abortAction: this.cancelDeleteZone,
            message: _("confirmationDeleteZoneMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: "yes",
            abortBtnLabel: "no",
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteZoneTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteBuIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteBu,
            abortAction: this.cancelDeleteBu,
            message: _("confirmationDeleteBuMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: "yes",
            abortBtnLabel: "no",
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteBuTitle"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settingSuggestions: state.collaborator.settingSuggestions
});

export default connect(mapStateToProps)(LocalizationSettingContent);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSetting/LocalizationSettingContent.js